import { Box, Button, Typography } from '@mui/material';
import React, { Dispatch, SetStateAction } from 'react';
import { SxClassProps } from '@/types';
import useResponsive from '@/components/hooks/useResponsive';
import { AnalyticsHelper } from '@/utilities/AnalyticsHelper';
import { AnalyticsEventName, CtaLocation, CtaText, ScreenName } from '@/types/enums';
import TestimonialsCarousel from './TestimonialsCarousel';
import { Testimonial } from './Testimonial';

const classes: SxClassProps = {
  root: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    px: 3,
    backgroundColor: theme.palette.care?.blue[100],
  }),
  testimonialsContainer: {
    justifyItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    flexDirection: { xs: 'column', lg: 'row' },
  },
  button: {
    alignSelf: 'center',
    width: { xs: '100%', sm: 150 },
    mt: { lg: 4 },
    mb: 6,
  },
};

export const testimonials = [
  {
    text: "Care.com has honestly been a real blessing for my family. We are newer to the city we live in and don't have a ton of friends and family to babysit our little ones. I have now found three really good sitters on Care.com and have been satisfied with the child care every time. I love the fact that many of the sitters have reviews and background checks.",
    name: 'Scott B.',
  },
  {
    text: 'I was skeptical as I never experienced hiring a caregiver for my dad, let alone through online services. Care.com made it simple and stress-free. It was easy to create an account and post help you needed. Within a short period of time caregivers started sending their applications. I was able to hire two caregivers and both are very caring and compassionate. Thanks to Care.com my family and I are now worry and stress free about my dad.',
    name: 'Cletus J.',
  },
  {
    text: 'This was the first time we needed to find a pet sitter to board our dog over night. Using Care.com made it very easy to find multiple people to choose from. Ultimately we were very happy with our choice, a loving and conscientious young woman to care for our dog. We were so happy with how well our dog did that we will be using her again in the very near future.',
    name: 'Nancy M.',
  },
];

const Testimonials = ({
  setOpenModalOrDrawer,
}: {
  setOpenModalOrDrawer: Dispatch<SetStateAction<boolean>>;
}) => {
  const { isDesktopLG } = useResponsive();

  const buttonHandler = () => {
    AnalyticsHelper.logEvent({
      name: AnalyticsEventName.CTA_INTERACTED,
      data: {
        screen_name: ScreenName.PLANS_AND_PRICING,
        enrollment_initiated: true,
        cta_text: CtaText.JOIN_NOW,
        cta_location: CtaLocation.TESTIMONIALS,
        vertical: 'Unknown',
      },
    });
    setOpenModalOrDrawer(true);
  };

  return (
    <Box data-testid="testimonials-section" sx={classes.root}>
      <Typography mt={6} mb={3} textAlign="center" variant={isDesktopLG ? 'display2' : 'display3'}>
        What families are saying
      </Typography>
      <Box sx={classes.testimonialsContainer}>
        {isDesktopLG ? (
          testimonials.map(({ text, name }, index) => (
            <Testimonial item={{ text, name }} index={index} key={`testimonial-card-${name}`} />
          ))
        ) : (
          <TestimonialsCarousel items={testimonials} />
        )}
      </Box>

      <Button
        onClick={buttonHandler}
        sx={classes.button}
        size="large"
        variant="contained"
        color="primary">
        Join now
      </Button>
    </Box>
  );
};

export default Testimonials;
